import React from 'react'
import { REACT_APP_API_ENDPOINT_GET_LOGIN_PARAMETROA, REACT_APP_API_ENDPOINT_GET_TOKEN_REFRESH } from '../../../Domain/Settings/SettingsVariables';
import { Get } from '../../HTTP/Get';
import { Post } from '../../HTTP/Post';
import { closeSession, getToken, isActive, getGeoMok } from '../FeatureGlobal';
import * as CryptoJS from "crypto-js";
import { Idle } from "idlejs/dist";

export const FeatureToken = () => {
    const { AxiosGet } = Get();
    const { AxiosPost } = Post();

    const Refresh =()=>{
        if (isActive()) {
            AxiosGet(`${REACT_APP_API_ENDPOINT_GET_LOGIN_PARAMETROA}`).then((res)=>{
              getGeoMok().then(succ=>{
                setInterval(() => {
                    let obj = {
                         usuario:'',
                         password:'', 
                         sitioUsuario:'',
                         sitioPassword:'',
                         ip:succ.data.ip,
                         tokenCaptcha:'',
                    }
                    AxiosPost(`${REACT_APP_API_ENDPOINT_GET_TOKEN_REFRESH}`,
                    obj, 
                    getToken()).then(succ => {
                        localStorage.setItem("token", CryptoJS.AES.encrypt(succ.token, "eco_scotia"));
                        localStorage.setItem("jwt",succ.token);
                      }).catch(error => {
                        //console.log(error);
                      });
                  }, 6000000);
                })
            }).catch((err)=>{
                //console.log(err);
            })
          }else{
            closeSession();
          }
          const idle = new Idle()
            .whenNotInteractive()
            .within(15)
            .do(() => {
              if (isActive()) {
                closeSession();
              }
            })
            .start();
    }
  return {
    Refresh
  }
}
